<template>
  <div class="recruitment-activation-success-component page-max-width footer-max-width">
    <QPageContainer>
      <QPage padding>
        <section class="recruitment-activation-success-section">
          <DemandActivated />
        </section>
      </QPage>
    </QPageContainer>

    <QFooter class="bg-transparent padding-0-15">
      <div class="margin-15-0">
        <QBtn
          class="full-width btn-navigation"
          color="secondary"
          :label="$t('ETAB.PAGES.RECRUITMENT.ACTIVATION.@SUCCESS_ACTION')"
          no-caps
          @click="goToExtra"
        />
      </div>
    </QFooter>
  </div>
</template>

<script>
  import { ETAB_ROUTES } from "@etab/config";
  import { GETTER_RECRUITMENT_GET_CURRENT } from "@etab/stores/types";
  import { useRecruitmentStore } from "@etab/stores/recruitment";
  import { mapState } from "pinia";

  import DemandActivated from "@etab/components/success/DemandActivated.component.vue";

  export default {
    components: {
      DemandActivated,
    },
    computed: {
      ...mapState(useRecruitmentStore, {
        recruitment: GETTER_RECRUITMENT_GET_CURRENT,
      }),
      demandId() {
        return this.$route.params.demandId;
      },
      demandType() {
        return this.$route.params.demandType;
      },
      extraId() {
        return this.$route.query.extraId;
      },
    },
    methods: {
      async goToExtra() {
        if (this.extraId) {
          this.$router
            .push({
              name: ETAB_ROUTES.dashboard.recruitment.permanent.candidate.profile.name,
              params: { demandId: this.demandId, demandType: this.demandType, candidateId: this.extraId },
            })
            .catch((suppressedError) => {});
          return;
        }
        // if not extraId set, we go back to the recruitment detail
        this.$router
          .push({
            name: ETAB_ROUTES.dashboard.recruitment.permanent.detail.root.name,
            params: { demandId: this.demandId, demandType: this.demandType },
          })
          .catch((suppressedError) => {});
      },
    },
  };
</script>

<style lang="scss">
  .recruitment-activation-success-component {
    .recruitment-activation-success-section {
      padding-top: 10vh;
    }
  }
</style>
